import { Constraints, Dictionary, ValidationResult } from './types';
import { find, forEach, mapValues } from 'lodash';

export function validate(constraints: Constraints, values: Dictionary) {
  const result: ValidationResult = {};

  forEach(constraints, (validators, name) => {
    const value = values[name];

    find(validators, validator => {
      const error = validator(value);

      if (error) {
        result[name] = error;
        return true;
      }

      return false;
    });
  });
  return result;
}

export function validateAndTranslate(
  constraints: Constraints,
  values: Dictionary,
  t: (...props: any[]) => string
) {
  return mapValues(validate(constraints, values), error => {
    return t(error.key, error.options);
  });
}

export const createValidator = (constraints: Constraints) => (values: Dictionary) =>
  validate(constraints, values);
